/**
 * Subtle founder/admin shortcuts — visible only to founder admins.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { Lock } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { isFounderAdmin } from '../../utils/adminAccess';

export function DashboardFounderLinks() {
  const { user } = useAuth();
  if (!isFounderAdmin(user)) return null;

  return (
    <div
      className="flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-[#7a7268]"
      data-testid="dashboard-founder-links"
    >
      <span className="inline-flex items-center gap-1 text-[#8b7355]/80">
        <Lock className="h-3 w-3" aria-hidden />
        Founder
      </span>
      <Link
        to="/admin/insights"
        className="underline decoration-[#c9a961]/30 underline-offset-4 transition hover:text-[#5c534a]"
        data-testid="dashboard-founder-insights"
      >
        Founder Insights
      </Link>
      <Link
        to="/admin/product-requests"
        className="underline decoration-[#c9a961]/30 underline-offset-4 transition hover:text-[#5c534a]"
        data-testid="dashboard-founder-product-requests"
      >
        Product Requests
      </Link>
    </div>
  );
}

export default DashboardFounderLinks;
